module.exports = __webpack_public_path__ + "static/media/upgrade.21b10de8.svg";